import { defineMessage } from 'services/localization';

export const messages = {
    accountNumber: defineMessage('account_number_accountnumber'),
    taxNumber: defineMessage('tax_id_taxnumber'),
};
